import React from "react";
import styled from "styled-components";
const ConsentDiv = styled.div `
    font-size: 80%;
    margin: 15px auto;

    & a {
        font-weight: normal;
        color: red;
        text-decoration: underline;
        cursor: pointer;
    }
`;
export const Consent = (props) => {
    return (React.createElement(ConsentDiv, null,
        "By logging in, you are reminded that you are bound by the reseller agreement terms and conditions; and that you accept the ",
        React.createElement("a", { href: props.privacyLink, target: "_blank" }, "Privacy Policy"),
        "."));
};
//# sourceMappingURL=index.js.map